const Chance = require('chance');

const chance = new Chance();

export default chance;
